import WebApp from "@twa-dev/sdk";

export function getTelegramUser() {
  const user = WebApp?.initDataUnsafe?.user;
  if (!user?.id) return null;

  return {
    id: user.id,
    firstName: user.first_name ?? "",
    lastName: user.last_name ?? "",
    username: user.username ?? "",
    languageCode: user.language_code ?? "",
  };
}

export function getTelegramInitData() {
  return WebApp?.initData ?? "";
}

export function initTelegramUi() {
  if (!WebApp) return;
  WebApp.ready();
  WebApp.expand();
}
